import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { Utils } from 'src/app/common/utils';
import { VproService } from 'src/app/service/vpro/vpro.service';
import { ExcelService } from 'src/app/service/excelDownload/excel.service';
import moment from 'moment';


@Component({
  selector: 'app-superadmin-appointment',
  templateUrl: './superadmin-appointment.component.html',
  styleUrls: ['./superadmin-appointment.component.css']
})
export class SuperadminAppointmentComponent implements OnInit {

  constructor(
   private service: VproService, private spinner: NgxSpinnerService, private utils: Utils, private formBuilder: UntypedFormBuilder,   private excelService: ExcelService

  ) { }
  appointmentData:any;
  public appointmentForm:UntypedFormGroup;
  public fromDate: string;
  public toDate: string;
  public noAppointment: boolean;
  public minDate: string;

  ngOnInit() {
    this.spinner.show();
    this.appointmentForm=this.formBuilder.group({
      fromDate:["",[Validators.required]],
      toDate:["",[Validators.required]]
    })

    this.appointmentForm.get('fromDate').valueChanges.subscribe((value)=>{
      if(value){
        this.minDate = value;
        this.appointmentForm.get("toDate").setValue("");
        this.appointmentForm.get("toDate").updateValueAndValidity();
      }
    })

    this.service.getAppointmentSuperadmin().subscribe((res)=>{
      this.spinner.hide();
      this.appointmentData = res; 
      this.noAppointment = false
      if(!res || res.length === 0 ){
        this.noAppointment = true
      }
    })
  }
  get appointmentFormControl(){
    return this.appointmentForm.controls;
  }

  findAppointments(){
    let currentDate = moment().format('YYYY-MM-DD')
    let { year=null, month=null, day=null } = this.appointmentForm.value.fromDate
    this.fromDate = year === null ? currentDate : `${year}-${month}-${day}`
    let { year:toYear=null, month:toMonth=null, day:toDay=null } = this.appointmentForm.value.toDate;
    console.log("currentdate",currentDate)
    this.toDate = year === null? currentDate : `${toYear}-${toMonth}-${toDay}`

    console.log("fromddate",this.fromDate)

    // if(!this.fromDate || !this.toDate ){
    //   this.fromDate === null ? currentDate : this.fromDate;
    //   this.toDate === null ? currentDate : this.toDate;
    // }
    this.spinner.show()
    // if(this.fromDate && this.toDate){
      this.service.getAppointmentSuperadmin(`?from=${this.fromDate}&to=${this.toDate}`).subscribe((res)=>{
        this.spinner.hide();
        this.appointmentData = res;
        this.noAppointment = false 
        if(!res || res.length === 0 ){
          this.noAppointment = true
        }
        console.log(this.appointmentData)
      })
    // }
  }

  public exportAsXLSX() {
    try {
    console.log("inside excel")
    let excelPatApts: any = [];
    let excelFileName: string = "";
    let excelSheetName: string = "";
    let personalInfo: any = [];
    if (this.appointmentData) {
      excelFileName = "_Appointments";
      excelSheetName = "Appointments";
      this.appointmentData.forEach(element => {
        excelPatApts.push({
          "APPT ID": element.aptid === null ? "Not Available" : element.aptid,
          "APPT DATE": element.apdate === null ? "Not Available" : moment(element.apdate, 'YYYY-MM-DD').format('DD-MMM-YYYY'),
          "APPT TIME": element.aptime === null ? "Not Available" : element.aptime,
          "PHYSICIAN NAME": ((element.physician_firstname === null ? "" : element.physician_firstname) + " " + (element.physician_lastname === null ? "" : element.physician_lastname)),
          "PHYSICIAN CONTACT":element.physician_contactno === null ? "Not Available" : element.physician_contactno,
          "PATIENT NAME": ((element.patient_firstname === null ? "" : element.patient_firstname) + " " + (element.patient_lastname === null ? "" : element.patient_lastname)),
          "PATIENT CONTACT": element.patient_contactno === null ? "Not Available" : element.patient_contactno,
          "APPT TYPE": element.apttype === null ? "Not Available" : element.apttype.replace('_', ' ').toUpperCase(),
          "STATUS": element.schedule_stat === null ? "Not Available" : element.schedule_stat.replace('_', ' ').toUpperCase()
        });
      });
      this.excelService.exportAsExcelFile(personalInfo, excelPatApts, excelFileName, excelSheetName);
    }

  }catch(e){
    console.log(e)
  }}

}
